(function () {
  function whenReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      // DOM already parsed ho chuka hai (defer/late-loaded script) — turant run karo
      fn();
    }
  }

  function getFieldsetLabel(fieldset) {
    const legend = fieldset.querySelector('legend');
    return legend ? legend.textContent.trim().toLowerCase() : '';
  }

  function resolveTargetMetal(colorValue) {
    const v = colorValue.toLowerCase();
    if (v.includes('silver')) return '925 silver';
    if (v.includes('gold')) return '18k gold vermeil'; // Gold + Rose Gold dono match
    return null;
  }

  function getFieldsetByPrefix(variantSelects, prefix) {
    let found = null;
    variantSelects.querySelectorAll('fieldset').forEach((fs) => {
      if (getFieldsetLabel(fs).startsWith(prefix)) found = fs;
    });
    return found;
  }

  // Wrong metal ko disable karta hai aur sahi metal ka input return karta hai
  function applyMetalRestrictions(variantSelects) {
    const colorFieldset =
      getFieldsetByPrefix(variantSelects, 'color') || getFieldsetByPrefix(variantSelects, 'colour');
    const metalFieldset = getFieldsetByPrefix(variantSelects, 'metal');
    if (!colorFieldset || !metalFieldset) return null;

    const checkedColor = colorFieldset.querySelector('.cvo-input:checked');
    if (!checkedColor) return null;

    const targetMetalValue = resolveTargetMetal(checkedColor.value);
    if (!targetMetalValue) return null;

    let correctMetalInput = null;
    metalFieldset.querySelectorAll('.cvo-input').forEach((metalInput) => {
      const metalValue = metalInput.value.trim().toLowerCase();
      const isAllowed = metalValue === targetMetalValue;
      const metalLabel = metalFieldset.querySelector(`label[for="${metalInput.id}"]`);
      metalInput.disabled = !isAllowed;
      if (metalLabel) {
        metalLabel.classList.toggle('cvo-pill--disabled', !isAllowed);
        metalLabel.classList.toggle('cvo-swatch--disabled', !isAllowed);
      }
      if (isAllowed) correctMetalInput = metalInput;
    });

    return correctMetalInput;
  }

  // Agar sahi metal already selected nahi hai, to uska LABEL click karo
  // (real click => real change event => variant-selects ka apna native
  // pipeline chalega, isliye 100% reliable rahega, guessing ki zaroorat nahi)
  function ensureCorrectMetalSelected(variantSelects) {
    const correctMetalInput = applyMetalRestrictions(variantSelects);
    if (!correctMetalInput || correctMetalInput.checked) return;

    const label = variantSelects.querySelector(`label[for="${correctMetalInput.id}"]`);
    if (label) {
      label.click();
    } else {
      correctMetalInput.checked = true;
      correctMetalInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('variant-selects').forEach((vs) => {
      if (vs.dataset.metalRestrictionInit === 'true') return;
      vs.dataset.metalRestrictionInit = 'true';
      ensureCorrectMetalSelected(vs);
    });
  }

  // 1) Color change hote hi turant wrong metal ko disable/block karo.
  //    Ye event document par delegate hai, isliye quick-add modal ke
  //    dynamically injected inputs ke liye bhi kaam karega.
  document.addEventListener('change', function (event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement)) return;
    if (input.type !== 'radio' || !input.classList.contains('cvo-input')) return;

    const fieldset = input.closest('fieldset');
    const label = fieldset ? getFieldsetLabel(fieldset) : '';
    if (!label.startsWith('color') && !label.startsWith('colour')) return;

    const variantSelects = input.closest('variant-selects');
    if (!variantSelects) return;

    applyMetalRestrictions(variantSelects);
  });

  // 2) Page load par jo variant-selects pehle se DOM mein maujood hain,
  //    unke liye initial sync.
  //    FIX: DOMContentLoaded ka blind wait nahi — agar event already fire
  //    ho chuka hai (defer/late script), to turant run karo.
  whenReady(function () {
    initAll(document);

    // Safety-net: kuch themes URL param / last-selected-variant state
    // DOMContentLoaded ke thodi der baad (async) apply karte hain.
    // Isliye ek chhota delay ke baad dobara verify kar lo.
    // (agar already sahi hai to yeh no-op rahega)
    setTimeout(function () {
      document.querySelectorAll('variant-selects').forEach((vs) => {
        ensureCorrectMetalSelected(vs);
      });
    }, 300);
  });

  // 3) MutationObserver — jab bhi koi naya variant-selects element DOM
  //    mein add ho (Quick View modal, Quick Add modal, section reload,
  //    ajax product-swap, etc.), turant usko initialize karega.
  //    Ye kisi bhi theme-specific custom event pe depend nahi karta,
  //    isliye quick view/quick add ke liye reliable hai.
  var metalRestrictionObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('variant-selects')) {
          initAll(node.parentElement || document);
        } else if (node.querySelectorAll) {
          var nested = node.querySelectorAll('variant-selects');
          if (nested.length) initAll(node);
        }
      });
    });
  });
  metalRestrictionObserver.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  // 4) Theme ka pub/sub agar available hai to usko bhi support karo
  //    (agar nahi hai to ye block harmless rahega).
  whenReady(function () {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
        const sectionId = event && event.data && event.data.sectionId;
        if (!sectionId) return;
        const variantSelects = document.querySelector(`variant-selects[data-section="${sectionId}"]`);
        if (!variantSelects) return;
        ensureCorrectMetalSelected(variantSelects);
      });
    }
  });
})();